import { FC } from "react";
import { ContentContainerProps } from "./types";

const TextRightContainer: FC<ContentContainerProps> = ({ children }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 items-center justify-center overflow-hidden [&>*:first-child]:order-1 [&>*:last-child]:order-2 md:[&>*:first-child]:order-none md:[&>*:last-child]:order-none">
      {children}
    </div>
  );
};

export default TextRightContainer;
